import { create } from 'zustand';

import type { EvidenceTimelineFetchResult } from '@/services/evidenceTimelineService';

export type EvidenceTimelineCacheEntry = EvidenceTimelineFetchResult;

interface EvidenceTimelineCacheState {
  cache: Record<string, EvidenceTimelineCacheEntry>;
  setCacheEntry: (key: string, entry: EvidenceTimelineCacheEntry) => void;
  getCacheEntry: (key: string) => EvidenceTimelineCacheEntry | undefined;
}

export function buildEvidenceTimelineCacheKey(row: {
  assocID?: string;
  geneSymbol?: string;
  variantStrID?: string;
  strID?: string;
  diseaseName?: string;
  source?: string;
}): string {
  const assoc = row.assocID != null ? String(row.assocID) : '';
  const gene = row.geneSymbol != null ? String(row.geneSymbol) : '';
  const variant = row.variantStrID ?? row.strID;
  const variantStr = variant != null ? String(variant) : '';
  const disease = row.diseaseName != null ? String(row.diseaseName) : '';
  const source = row.source != null ? String(row.source) : '';
  if (assoc) return `assoc:${assoc}|src:${source}`;
  if (variantStr) return `vda:${source}|${variantStr}|${disease}`;
  return `gda:${source}|${gene}|${disease}`;
}

export const useEvidenceTimelineCacheStore = create<EvidenceTimelineCacheState>((set, get) => ({
  cache: {},
  setCacheEntry: (key, entry) =>
    set(s => ({
      cache: { ...s.cache, [key]: entry },
    })),
  getCacheEntry: key => get().cache[key],
}));
